var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-session-list"},_vm._l((_vm.sessionHistory),function(session){return _c('session-list-item',{key:session.id,attrs:{"session":session}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }